'use client'

// src/ArrowUp.tsx
import { createIcon } from "@chakra-ui/icon";
var ArrowUpIcon = createIcon({
  d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z",
  displayName: "ArrowUpIcon"
});

export {
  ArrowUpIcon
};
//# sourceMappingURL=chunk-UAAL6Z4U.mjs.map